import React, { useState, useEffect } from "react";
import { database, onValue, ref, set, off } from "../../services/firebase";
import { JaaSMeeting } from "@jitsi/react-sdk";
import { CallToAction, DisplayScreen } from "@unlimited-robotics/ur-ui-kit";

const JitsiPage = () => {
  const [step, setStep] = useState(0);

  const [roomData, setRoomData] = useState({
    roomId: "",
    password: "",
  });

  const [garyId, setGaryId] = useState(localStorage.getItem("garyId"));

  useEffect(() => {
    let id = localStorage.getItem("garyId");
    if (!id) {
      id = "gary" + Math.floor(Math.random() * 100000);
      localStorage.setItem("garyId", id);
    }
    setGaryId(id);

    const statusListener = ref(database, "requests/ui-kit/" + id);

    onValue(statusListener, (snapshot) => {
      const data = snapshot.val();
      if (data?.password) {
        setRoomData({
          roomId: data.roomId,
          password: data.password,
        });
        setStep(2);
      } else {
        setStep(0);
      }
    });

    return () => {
      off(statusListener);
    };
  }, []);

  const hanldeCallRequest = () => {
    set(ref(database, "requests/ui-kit/" + garyId), {
      status: false,
    });
    setStep(1);
  };

  const onCallClose = () => {
    set(ref(database, "requests/ui-kit/" + garyId), null);
    setStep(0);
  };

  return (
    <div
      className="jitsi"
      style={{
        height: "100vh",
      }}
    >
      {step === 0 && (
        <CallToAction
          title="Hello, Can I Help you?"
          subtitle="Click below to call the nurse"
          button_text="Call the nurse"
          theme="DARK"
          button_size="MEDIUM"
          callback={hanldeCallRequest}
        />
      )}
      {step === 1 && (
        <DisplayScreen
          title="Loading..."
          subtitle="waiting for nurse to answer"
          show_loader={false}
          theme="DARK"
        />
      )}

      {step === 2 && (
        <JaaSMeeting
          appId={process.env.REACT_APP_JITSI_APP_ID}
          roomName={roomData.roomId}
          configOverwrite={{
            disableThirdPartyRequests: true,
            disableLocalVideoFlip: true,
            backgroundAlpha: 0.5,
            prejoinPageEnabled: false,
            startWithAudioMuted: false,
            startWithVideoMuted: true,
          }}
          userInfo={{
            displayName: "Patient",
          }}
          interfaceConfigOverwrite={{
            VIDEO_LAYOUT_FIT: "nocrop",
            MOBILE_APP_PROMO: false,
            TILE_VIEW_MAX_COLUMNS: 4,
            TOOLBAR_ALWAYS_VISIBLE: true,
          }}
          onApiReady={(externalApi) => {
            externalApi.on("readyToClose", onCallClose);
            // externalApi.on("passwordRequired", () => {
            //   externalApi.executeCommand("password", roomData.password);
            // });
          }}
          getIFrameRef={(iframeRef) => {
            iframeRef.style.height = "100%";
            iframeRef.style.width = "100%";
          }}
        />
      )}
    </div>
  );
};

export default JitsiPage;
